<div>
  <div class="col-12">
    <div class="info-text text-center">
      <h3 class="description-text">
        {{ 'PASSWORD-CHANGE.TITLE-TEXT' | translate }}
      </h3>
    </div>
    <div class="d-flex justify-content-center above-errors">
      <div *ngIf="oldPasswordEqualNewPassword" class="error-message">
        <span>
          {{ 'PASSWORD-CHANGE.OLD-PASSWORD-EQUAL-NEW-PASSWORD' | translate }}
        </span>
      </div>

      <div
        *ngIf="
          !!newPassword && newPassword.length < 6 && newPasswordInput.invalid
        "
        class="error-message"
      >
        <span>
          {{ 'PASSWORD-CHANGE.PASSWORD-AT-LEAST-6-CHARS' | translate }}
        </span>
      </div>
      <div
        *ngIf="
          !!newPassword && newPassword.length >= 6 && newPasswordInput.invalid
        "
        class="error-message"
      >
        <span>
          {{ 'PASSWORD-CHANGE.PASSWORD-VALIDATION-RULES' | translate }}
        </span>
      </div>

      <div
        *ngIf="
          newPasswordInput.valid &&
          !!this.confirmedPassword &&
          this.confirmedPassword.length > 0 &&
          !passwordConfirmed
        "
        class="error-message"
      >
        <span>
          {{ 'PASSWORD-CHANGE.NEW-AND-CONFIRMED-PASSWORD-RULE' | translate }}
        </span>
      </div>
    </div>
    <div class="text-center">
      <form
        class="d-flex flex-column align-items-center"
        #changePassword="ngForm"
        id="reset-password-container"
      >
        <mat-form-field class="reset-password-field">
          <input
            autocomplete="off"
            type="password"
            matInput
            placeholder="{{ 'PASSWORD-CHANGE.LABEL-NEW-PASSWORD' | translate }}"
            pattern="(?=.*[A-Z])(?=.*[0-9])(?=.*[!@$?_-])[A-Za-z\d!@$?_-].{5,}"
            id="new-password"
            [(ngModel)]="newPassword"
            #newPasswordInput="ngModel"
            name="new-password"
            required
          />
        </mat-form-field>

        <mat-form-field class="reset-password-field">
          <input
            autocomplete="off"
            type="password"
            matInput
            placeholder="{{
              'PASSWORD-CHANGE.LABEL-CONFIRM-PASSWORD' | translate
            }}"
            id="confirmed-password"
            [(ngModel)]="confirmedPassword"
            #ConfirmPassword="ngModel"
            name="confirmed-password"
            required
          />
        </mat-form-field>

        <div class="buttons btns-left">
          <a [routerLink]="['/login']" id="back-link" class="back-link">{{
            'REGISTRATION.BACK-TO-LOGIN' | translate
          }}</a>
          <button
            [disabled]="
              !allDataAvailable || !passwordConfirmed || !newPasswordInput.valid
            "
            id="btnConfirmPass"
            class="btn btn-primary btn-large loading-button submit-btn"
            (click)="confirm()"
          >
            {{ 'PASSWORD-CHANGE.BUTTON-CONFIRM' | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
